import { graphql } from '@/generated/gql';

export const DEMAND_DETAIL_QUERY = graphql(/* GraphQL */ `
  query DemandDetail($id: UUID!) {
    tesseract {
      demand(id: $id) {
        id
        competitiveBiddingRule {
          id
          variant
          deadline
          isEditable
          isMaskedBidding
        }
        capabilityIds
        responsibleUserIds
        status
        demandRequest {
          id
          commodityGroupId
          externalReference
          sourceReferences {
            url
          }
          lineItems {
            id
            preferredSupplierId
            commodityGroupId
          }
        }
        permissions {
          write
        }
        createdAt
        sequenceNumber
        priority
        processingMode
        updatedAt
        negotiationCases {
          nodes {
            id
            options {
              id
              quoteMode
            }
          }
        }
      }
    }
  }
`);
